import {action, observable} from 'mobx'
import {EditorState, ContentState, CompositeDecorator} from 'draft-js'

export class Signal {
  @observable text
  @observable editorState

  constructor(text = '') {
    this.text = text
    this.editorState = EditorState.createWithContent(ContentState.createFromText(text))
  }

  @action change(editorState) {
    this.editorState = editorState
    this.text = editorState.getCurrentContent().getPlainText()
  }

  @action decorate(decorators) {
    const compositeDecorator = new CompositeDecorator(Object.values(decorators))
    this.editorState = EditorState.set(
      this.editorState,
      {decorator: compositeDecorator}
    )
  }
}
